import React, {Component} from "react";
import {observer, inject} from "mobx-react";
import {Popover} from "antd";
import classnames from "classnames";

import File from "../component/MenuLeft/File";
import Help from "../component/MenuLeft/Help";
import Pattern from "../component/MenuLeft/Pattern";
import Function from "../component/MenuLeft/Function";
import Theme from "../component/MenuLeft/Theme";
import CodeTheme from "../component/MenuLeft/CodeTheme";
import Setting from "../component/MenuLeft/Setting";
import View from "../component/MenuLeft/View";
import WordCount from "../component/WordCount";

import "./Navbar.css";

// @inject("userInfo")
@inject("view")
@observer
class Navbar extends Component {
  render() {
    const {title} = this.props;
    const {isImmersiveEditing} = this.props.view;
    const niceNavbarClass = classnames({
      "nice-navbar": true,
      "nice-navbar-hide": isImmersiveEditing,
    });
    return (
      <div className={niceNavbarClass}>
        <div className="nice-left-nav">
          {title === "" ? null : (
            <section id="nice-title" className="nice-title">
              {title}
            </section>
          )}
          <File />
          <Pattern />
          <Function />
          <View />
          <Theme />
          <CodeTheme />
          <Setting />
          <Help />
        </div>
        <div className="nice-right-nav">
          <WordCount />
          <Popover
            content={
              <div style={style.qrCodeContainer}>
                <img
                  src="/javapub-qr-code.png"
                  alt="JavaPub 公众号二维码"
                  style={style.qrCode}
                />
                <p style={style.qrCodeText}>扫码关注 JavaPub</p>
              </div>
            }
            title="关注公众号"
            trigger="hover"
            placement="bottomRight"
          >
            <section className="nice-wechat-public" style={{cursor: "pointer"}}>
              公众号 <strong>JavaPub</strong>
            </section>
          </Popover>
        </div>
      </div>
    );
  }
}

const style = {
  qrCodeContainer: {
    textAlign: "center",
    padding: "10px",
  },
  qrCode: {
    width: "200px",
    height: "200px",
    display: "block",
    margin: "0 auto",
  },
  qrCodeText: {
    marginTop: "10px",
    marginBottom: "0",
    fontSize: "14px",
    color: "#333",
  },
};

export default Navbar;
